<template>
  <div class="order-detail">
    <navbar left-text show-home title="订单详情"></navbar>
    <div class="status" v-if="orderDetail"
      >{{ orderDetail.order.status_text }}
      <div v-if="detailStatus === 1">
        <div class="time">支付剩余时间：
          <div>
            <!-- <u-count-down
              ref="uCountDown"
              :timestamp="orderDetail.order.remaining_time"
              bg-color="#FF9A32"
              separator-color="#ffffff"
              color="#ffffff"
              :show-hours="false"
              @end="timeEnd"
            ></u-count-down> -->
            <count-down
              :endTime="((orderDetail.order.remaining_time * 1000) + countDown.startTime)"
              :startTime="countDown.startTime"
              @endCallback="timeEnd"
              endText="订单已失效"
            ></count-down>
          </div>
        </div>
      </div
    ></div>
    <div class="order-wrappter" v-if="orderDetail">
      <!-- 店铺信息 -->
      <div class="store">
        <div class="store-l">
          <div class="store-logo">
            <image
              lazy-load
              :src="orderDetail.shop.logo"
              mode="aspectFit"
            ></image>
          </div>
        </div>
        <div class="store-r">
          <div class="store-name u-line-1">{{ orderDetail.shop.name }}</div>
          <div class="store-address u-line-1"
            >地址：{{ orderDetail.shop.address }}</div
          >
        </div>
      </div>
      <!-- 场次信息 -->
      <div
        class="place"
        v-for="(item, index) in orderDetail.order.sport_order_item"
        :key="index"
      >
        <div class="place-item"
          >场地：<span
            >{{ item.ground_name }}{{ orderDetail.info.name }}馆</span
          ></div
        >
        <div class="place-item"
          >场次：<span>{{ item.session }}</span></div
        >
        <div class="place-item"
          >使用日期：<span>{{ item.cur_date }}</span></div
        >
        <span class="price">￥{{ item.price }} * {{ item.buy_num }}</span>
        <div
          @click="qrcodeShow(item)"
          class="qrcode"
          v-if="orderDetail.order.status === 2"
          >二维码</div
        >
      </div>
      <orderInfo
        :payDetail="orderDetail.discount"
        :detail="orderDetail.order"
      />
      <playground-detail :storeContent="orderDetail.info" />
    </div>

    <div class="footer" v-if="orderDetail">
      <!-- <button class="u-reset-button" open-type="contact">
        <u-icon name="kefu-ermai" color="#919191" size="45"></u-icon>
      </button> -->
      <div class="btn bg1" v-if="detailStatus === -1">已取消</div>
      <div @click="payNow" class="btn" v-else-if="detailStatus === 1"
        >立即支付</div
      >
      <!-- 2待使用3已使用 -->
      <!-- <template v-else-if="detailStatus === 2 || detailStatus === 3"> -->
        <!-- <div
          class="btn"
          @click="refundMoney"
          v-if="orderDetail.order.show_refund"
          >申请退款</div
        >
        <div class="btn bg1" v-else>申请退款</div> -->
        <div v-else-if="detailStatus === 2 || detailStatus === 3" class="hint">如需退订场馆请到包钢福利平台联系客服处理。</div>
      <!-- </template> -->

      <div class="btn bg1" v-else>{{ orderDetail.order.status_text }}</div>
    </div>
    <!-- <m-order-qrcode
      @qrcodeHide="qrcodeHide"
      :popQrcode="popQrcode"
    ></m-order-qrcode> -->
    <popup v-model="showQrcode.show">
      <div class="qrcode-box">
        <div class="img-box">
          <img :src="showQrcode.qrcode" alt="">
        </div>
      </div>
    </popup>
    <popup v-model="popTipsShow" mode="center">
      <div class="popTips">
        <div class="text">确定申请退款吗</div>
        <div class="btn">
          <button class="u-reset-button" @click="refundClose">取消</button>
          <button class="u-reset-button" @click="goRefund">确认</button>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import { mapState } from 'vuex'
import CountDown from '@/components/CountDown'
import OrderInfo from './orderInfo.vue'
import PlaygroundDetail from './playgroundDetail.vue'
export default {
  components: {
    OrderInfo, CountDown, PlaygroundDetail, Popup
  },
  props: {
    type: {
      type: String,
      default: 'shop_coupon'
    },
    oid: {
      type: String
    }
  },
  data () {
    return {
      popTipsShow: false,
      countDown: {
        loseEfficacy: false,
        startTime: new Date().getTime()
      },
      showQrcode: {
        show: false,
        img: ''
      },
      detailStatus: -2,
      status: '',
      orderDetail: null,
      popupStatus: false
    }
  },
  computed: {
    ...mapState('order', ['updateOrderStatus'])
  },
  watch: {
    updateOrderStatus (newVal) {
      if (newVal) {
        this.getOrderDetail()
        this.popQrcode.show = false
      }
    }
  },
  mounted () {
    this.getOrderDetail()
  },
  methods: {
    qrcodeHide () {
      this.showQrcode.show = false
    },
    refundClose () {
      this.popTipsShow = false
    },
    refundMoney () {
      this.popTipsShow = true
    },
    timeEnd () {
      this.orderDetail.order.status_text = '已取消'
      this.detailStatus = -1
      // this.getOrderDetail()
    },
    async goRefund () {
      this.popTipsShow = false
      this.$loading('请稍候...')
      const { code, msg } = await this.$api.getApplyRefund(this.orderDetail.order.id)
      if (code === 0) {
        this.getOrderDetail()
      } else {
        this.$toast(msg)
      }
    },
    async payNow () {
      this.$toast('请到铁花场馆预约小程序内支付')
      /* this.$loading('请稍候...')
      const { code, msg, data } = await this.$api.payHandler({
        order_type: 'sport',
        trade_id: this.orderDetail.order.order_sn
      })
      if (code === 0) {
        this.$loading('请稍候...')
        await this.$config.payHandler(
          { type: 'sport', order_id: this.orderDetail.order.id, ...data, self: this },
          () => { },
          () => {
            // this.$config.orderTempMsgHandler('complate');
            setTimeout(() => {
              flag = false
            }, 1500)
          }
        )
      } else {
        this.$toast(msg)
        flag = false
      } */
    },
    async qrcodeShow (item) {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get(`5gadmin/customer/api/sport/qrcode?cardkey=${item.cardkey}&size=100`)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          // this.$connectSocket()
          this.showQrcode.img = data.qr_code
          this.showQrcode.show = true
        } else {
          this.$toast(msg)
        }
      }
      this.$toast.clear()
    },
    async getOrderDetail () {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get(`5gadmin/customer/api/sport/detail?order_id=${this.oid}`)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.orderDetail = data
          this.detailStatus = data.order.status// -1已取消0下单中1未支付2待使用3已使用4已申请退票99系统处理中
        } else {
          this.$toast(msg)
        }
      }
      this.$toast.clear()
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail {
  padding-bottom: 1.1rem;
  .popTips {
    background: #fff;
    border-radius: .2rem;
    width: 6rem;
    padding: 0 .34rem .34rem;
    color: #000;
    .text {
      padding-bottom: .85rem;
      padding-top: .9rem;
      font-size: .28rem;
      text-align: center;
    }
    .btn {
      margin: 0 .2rem;
      .flex-between;
      button {
        width: 2.1rem;
        line-height: .7rem;
        height: .7rem;
        border-radius: .35rem;
        border: solid .01rem #ff9a32;
        text-align: center;
        color: #ff9a32;
        &:nth-child(2) {
          background: #ff9a32;
          color: #fff;
        }
      }
    }
  }
  .status {
    height: 1.12rem;
    width: 100%;
    background: #ff9a32;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: .36rem;
    padding-left: .46rem;
    .time {
      font-size: .26rem;
      margin-left: .26rem;
      display: flex;
    }
  }
  .order-wrappter {
    padding: .2rem;
    .store {
      background: #fff;
      border-radius: .14rem;
      display: flex;
      padding: .24rem;
      .store-logo {
        width: 1.33rem;
        height: 1rem;
        border-radius: .08rem;
        overflow: hidden;
      }
      &-r {
        width: 5.1rem;
        margin-left: .24rem;
        .store-name {
          font-size: .34rem;
          font-weight: bold;
        }
        .store-address {
          margin-top: .2rem;
          line-height: .4rem;
          height: .4rem;
          color: #8c8c8c;
          font-size: .22rem;
          background: url(https://image.buslive.cn/wfs/static2/mini_program/pe-venue/order/address.png)
            left center no-repeat;
          background-size: .22rem auto;
          box-sizing: border-box;
          padding-left: .3rem;
        }
      }
    }
    .place {
      margin-top: .2rem;
      background: #fff;
      border-radius: .14rem;
      padding: .24rem;
      line-height: .45rem;
      font-size: .28rem;
      color: #919191;
      position: relative;
      span {
        color: #000;
      }
      .price {
        color: #ff5151;
        position: absolute;
        top: .3rem;
        right: .2rem;
        line-height: .45rem;
      }
      .qrcode {
        position: absolute;
        right: .2rem;
        bottom: .3rem;
        text-align: center;
        color: #fff;
        font-size: .24rem;
        width: 1.4rem;
        line-height: .54rem;
        height: .54rem;
        background: #50acff;
        border-radius: .35rem;
      }
    }
  }
  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: .15rem .3rem;
    background: #fff;
    // @include flex-between;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      width: 2.1rem;
      line-height: .8rem;
      height: .8rem;
      border-radius: .08rem;
      background: #ff5151;
      text-align: center;
      color: #fff;
      font-size: .28rem;
      &.bg1 {
        background: #ffb9b9;
      }
    }
    .hint{
      width: 100%;
      text-align: center;
      font-size: .28rem;
    }
    button {
      border: none;
    }
  }
}
</style>
